export const IconBulb = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0 }}
    >
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M12 2a7 7 0 0 0-4.9 11.9 2 2 0 0 1 .5 1.4v.2a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-.2a2 2 0 0 1 .5-1.4A7 7 0 0 0 12 2Z" />
    </svg>
  );
};
